import {
  ColDef,
  GetContextMenuItemsParams,
  GridApi,
  GridReadyEvent,
  RowClickedEvent,
  RowDoubleClickedEvent,
  SelectionChangedEvent,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import { RemoveConfirmation } from "modules/common/components/form/RemoveConfirmation";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { agGridEntityContextMenu } from "modules/common/components/table/EntityContextMenu";
import { GridTheme } from "modules/common/components/table/GridTheme";
import { Pager } from "modules/common/components/table/Pager";
import { DefaultAgGridOptions, rowIdBy } from "modules/common/services/table/helpers";
import { OrderConfirmSnapshotType, SaveConfirm, mapConfirm } from "modules/orders-manage/models/order-confirm";
import { agGridLocale } from "modules/root/services/locale";
import { routes } from "modules/common/routes";
import React from "react";
import { Actions } from "./Actons";
import { ConfirmDetals } from "./Details";
import { Filters } from "./Filters";
import styles from "./List.module.scss";
import { StoreContract } from "./types";
import { Constants } from "modules/root/models/constants";
import { StringifiedOrderLinkType } from "modules/orders-manage/models/order-link";
import { Link } from "react-router-dom";
import { OrderTabs } from "modules/orders-manage/details/OrderDetailsTabsPage";
import { orderTitle } from "modules/orders-manage/models/order";

import { FileLink } from "modules/common/components/files/FileLink";
import { eat } from "modules/common/services/typescript";

const removeLabel = (what: OrderConfirmSnapshotType[]) => {
  if (!what) {
    return "";
  }

  const prefix = what.length > 1 ? "записи" : "запись";
  const numbers = what.map((m) => m.number);

  return `${prefix} ${numbers.join(", ")}`;
};

export class ConfirmsList extends React.PureComponent<ConfirmsListProps, ConfirmsListState> {
  private options = DefaultAgGridOptions(true);
  private gridApi: GridApi | null = null;

  constructor(props: ConfirmsListProps) {
    super(props);

    const { columns, canManage } = props;

    this.state = { selection: [], editable: null, assigment: [], colDefs: columns(canManage), showTools: false };
  }

  componentDidUpdate(prevProps: ConfirmsListProps) {
    if (this.props.canManage !== prevProps.canManage) {
      this.setState({ colDefs: this.props.columns(this.props.canManage) });
    }

    if (this.props.current !== prevProps.current) {
      if (this.gridApi) {
        const row = this.props.current ? this.gridApi.getRowNode(this.getRowNodeId(this.props.current)) : null;

        if (row) {
          row.setSelected(true, true);
        } else {
          this.gridApi.deselectAll();
        }
      }
    }

    // select single mail
    if (this.props.data !== prevProps.data && this.props.data.length === 1) {
      this.props.onConfirmSelected(this.props.data[0]);
    }
  }

  render() {
    const store = this.props;
    const { canManage, data, rowBuffer, hideProject, isActiveTab } = this.props;
    const { editable, colDefs, selection, showTools } = this.state;

    return (
      <div className={`mails ${styles.list}`}>
        {!!editable && (
          <ConfirmDetals
            confirm={editable}
            onClose={this.closeDialog}
            orders={store.orders}
            title="Подтвержение изменений"
            onRemove={this.removeSingleConfirm}
            onSubmit={this.onSubmit}
            upload={store.upload}
            baseUrl={store.baseUrl}
            hideProject={hideProject}
          />
        )}

        <RemoveConfirmation<OrderConfirmSnapshotType[]>
          observation={data}
          what={removeLabel}
          onConfirmed={store.remove}
          render={({ confirmRemoving }) => {
            const getContextMenuItems = canManage
              ? ({ node }: GetContextMenuItemsParams) => {
                // меню вызвано не на строке — показывать нечего
                if (!node) {
                  return [];
                }

                return agGridEntityContextMenu({
                  onChange: () => this.openDialog(node.data),
                  onRemove: () => confirmRemoving([node.data]),
                });
              }
              : undefined;

            return (
              <>
                <div className={styles.mobileTools}>
                  {canManage && (
                    <Actions confirms={this.state.selection} onRemove={confirmRemoving} onAdd={this.openNewDialog} />
                  )}
                  <PlanrButton
                    type={showTools ? "blueish" : "lightblueish"}
                    icon="general-dots-more"
                    round
                    onClick={this.toggleShowTools}
                  />
                </div>
                {showTools && (
                  <div className={styles.dialogTools}>
                    <Filters
                      filtersStatus={store.filtersStatus}
                      filtersType={store.filtersType}
                      query={store.query}
                      setFiltersType={store.setFiltersType}
                      setQuery={store.setQuery}
                      toggleFiltersStatus={store.toggleFiltersStatus}
                      setOrderId={store.setOrderId}
                      hideProject={hideProject}
                      orders={store.orders}
                    >
                      <div className={styles.actions}>
                        <PlanrButton
                          type="graybtn"
                          icon={"general-download"}
                          onClick={this.batchDownload}
                          round={true}
                          title="Скачать файлы результата"
                          size="small"
                        />
                        <PlanrButton
                          type="graybtn"
                          icon={"general-print"}
                          onClick={this.batchPrint}
                          round={true}
                          title="Печать"
                          size="small"
                        />
                      </div>
                    </Filters>
                  </div>
                )}
                <div className={styles.tools}>
                  {canManage && (
                    <Actions confirms={this.state.selection} onRemove={confirmRemoving} onAdd={this.openNewDialog} />
                  )}
                  <Filters
                    filtersStatus={store.filtersStatus}
                    filtersType={store.filtersType}
                    query={store.query}
                    setFiltersType={store.setFiltersType}
                    setQuery={store.setQuery}
                    toggleFiltersStatus={store.toggleFiltersStatus}
                    setOrderId={store.setOrderId}
                    hideProject={hideProject}
                    orders={store.orders}
                  >
                    <div className={styles.actions}>
                      <PlanrButton
                        type="graybtn"
                        icon={"general-download"}
                        onClick={this.batchDownload}
                        round={true}
                        title="Скачать файлы результата"
                        size="small"
                      />
                      <PlanrButton
                        type="graybtn"
                        icon={"general-print"}
                        onClick={this.batchPrint}
                        round={true}
                        title="Печать"
                        size="small"
                      />
                    </div>
                  </Filters>
                </div>

                {isActiveTab && (
                  <GridTheme bordered={true} className={styles.Mailtable}>
                    <AgGridReact
                      rowStyle={{
                        border: "none",
                        borderBottom: "1px solid #EDF0F2",
                        fontFamily: "GothamPro, Arial, sans-serif",
                        color: "#00273D",
                        fontSize: "12px",
                      }}
                      rowSelection="multiple"
                      enableCellTextSelection={true}
                      columnDefs={colDefs}
                      rowData={data}
                      localeText={agGridLocale}
                      getRowId={this.getRowId}
                      gridOptions={this.options}
                      detailCellRenderer="detailCellRenderer"
                      masterDetail={true}
                      groupDefaultExpanded={0}
                      context={this}
                      suppressCellFocus={true}
                      onGridReady={this.onGridReady}
                      onSortChanged={store.resorted}
                      onSelectionChanged={this.onSelectionChanged}
                      onRowDoubleClicked={this.onRowDoubleClicked}
                      getContextMenuItems={getContextMenuItems}
                      onRowClicked={this.onRowClicked}
                      rowBuffer={rowBuffer}
                      onRowDataUpdated={() => {
                        this.gridApi?.resetRowHeights();
                      }}
                      detailRowAutoHeight
                    />
                  </GridTheme>
                )}

                <div className={styles.cardList}>
                  {data.map((row) => {
                    let color = "#ff4949";
                    if (row.type === Constants.orderConfirmTypes[Constants.orderConfirmTypes.length - 1]) {
                      color = "#63ff63";
                    }
                    const selected = selection.find((s) => s.id === row.id);
                    const order = row.order as StringifiedOrderLinkType;

                    return (
                      <div key={row.id}>
                        {/* <div className={selected ? styles.cardSelected : styles.card}> */}
                        <div className={styles.card}>
                          <div className={styles.line} style={{ backgroundColor: color }}></div>
                          <div className={styles.mid}>
                            <div className={styles.row}>
                              <div className={styles.rowItem}>{row.type}</div>
                            </div>
                            <div className={styles.row}>
                              <div className={styles.rowItem}>{row.number}</div>
                              <div className={styles.rowItem}>{row.day}</div>
                            </div>
                            {order && (
                              <div className={styles.row}>
                                <div className={styles.rowItem}>
                                  <Link to={routes.orders.details(order.id, OrderTabs.orderConfirm)}>
                                    {orderTitle({ fullInventoryNumber: order.inventoryNumber, name: order.name })}
                                  </Link>
                                </div>
                              </div>
                            )}
                            <div className={styles.fileRow}>
                              {row.requestFiles.map((file, index) => (
                                <FileLink
                                  baseUrl={store.baseUrl}
                                  file={{ fileId: file.id, fileName: `Файл замечания №${index + 1}` }}
                                  key={file.id}
                                  onRemove={eat}
                                  readOnly
                                  style={{ width: "240px" }}
                                />
                              ))}
                            </div>
                            <div className={styles.fileRow}>
                              {row.sourceFiles.map((file, index) => (
                                <FileLink
                                  baseUrl={store.baseUrl}
                                  file={{ fileId: file.id, fileName: `Исходный файл №${index + 1}` }}
                                  key={file.id}
                                  onRemove={eat}
                                  readOnly
                                  style={{ width: "240px" }}
                                />
                              ))}
                            </div>
                            <div className={styles.fileRow}>
                              {row.resultFiles.map((file, index) => (
                                <FileLink
                                  baseUrl={store.baseUrl}
                                  file={{ fileId: file.id, fileName: `Файл результата №${index + 1}` }}
                                  key={file.id}
                                  onRemove={eat}
                                  readOnly
                                  style={{ width: "240px" }}
                                />
                              ))}
                            </div>
                            <div className={styles.label}>Принадл к комплектам:</div>
                            <div className={styles.row}>
                              <div
                                className={styles.rowItem}
                                style={{ wordBreak: "normal", lineHeight: "unset", whiteSpace: "pre-line" }}
                              >
                                {row.belonging}
                              </div>
                            </div>
                          </div>
                          <div className={styles.edit}>
                            <PlanrButton
                              type="lightblueish"
                              icon="general-edit"
                              size="small"
                              onClick={() => {
                                this.props.canManage && this.openDialog(row);
                              }}
                            />
                            <PlanrButton
                              type="neutral"
                              icon={selected ? "general-checkbox" : "general-zero-checkbox"}
                              size="small"
                              style={{ marginLeft: "0px", marginTop: "5px" }}
                              onClick={() => {
                                let newArr = [...selection];
                                const index = newArr.findIndex((s) => s.id === row.id);
                                if (index > -1) {
                                  newArr.splice(index, 1);
                                } else {
                                  newArr.push(row);
                                }
                                this.setState({ selection: [...newArr] });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {store.pager && (
                    <Pager
                      itemsPerPage={store.pager.pageSize}
                      page={store.pager.page}
                      totalItems={store.pager.totalCount}
                      pageSelected={store.setPage}
                      small={true}
                      hideIfEmpty={true}
                      pagesNumber={7}
                    />
                  )}
                </div>
              </>
            );
          }}
        />
        <div className={styles.pages}>
          {store.pager && (
            <Pager
              itemsPerPage={store.pager.pageSize}
              page={store.pager.page}
              totalItems={store.pager.totalCount}
              pageSelected={store.setPage}
              small={true}
              hideIfEmpty={true}
            />
          )}
        </div>
      </div>
    );
  }

  removeSingleConfirm = async (mail: SaveConfirm) => {
    const success = await this.props.remove([mail]);
    success && this.closeDialog();
  };

  startAssignment = (mails: OrderConfirmSnapshotType[]) => this.setState({ assigment: mails });

  openNewDialog = () => this.openDialog(this.props.mailFactory());
  toggleShowTools = () => this.setState({ showTools: !this.state.showTools });
  onSubmit = async (mail: SaveConfirm) => {
    const success = await this.props.save(mail);

    if (success) {
      this.closeDialog();

      const refresh = this.props.data.find((m) => m.id === mail.id);
      if (refresh) {
        this.props.onConfirmSelected(refresh);
      }
    }

    return success;
  };

  onRowClicked = ({ data }: RowClickedEvent) => {
    const mail: OrderConfirmSnapshotType = data;
    this.props.onConfirmSelected(mail);
  };

  onRowDoubleClicked = ({ data }: RowDoubleClickedEvent) => this.props.canManage && this.openDialog(data);

  openDialog = (mail: OrderConfirmSnapshotType) => {
    this.setState({ editable: mapConfirm(mail) });
    if (this.gridApi) {
      const node = this.gridApi.getRowNode(this.getRowNodeId(mail));
      node && node.setSelected(true, true);
    }
  };

  closeDialog = () => this.setState({ editable: null });

  onSelectionChanged = (e: SelectionChangedEvent) => {
    const selection = e.api.getSelectedNodes().map((n) => n.data);
    this.setState({ selection });
  };

  getRowNodeId = (node: OrderConfirmSnapshotType) => node.id;
  getRowId = rowIdBy(this.getRowNodeId);

  onGridReady = async ({ api }: GridReadyEvent) => {
    const { sorter } = this.props;
    setTimeout(() => api.applyColumnState(sorter.agGridSortState));
    this.gridApi = api;
    api.resetRowHeights();
    this.gridApi.resetRowHeights();
  };

  batchPrint = () => {
    const { selection } = this.state;
    if (selection.length) {
      this.props.printMails(selection.map((m) => m.id));
    }
  };

  batchDownload = () => {
    const { selection } = this.state;
    if (selection.length) {
      this.props.downloadMails(selection.map((m) => m.id));
    }
  };
}

interface ConfirmsListProps extends StoreContract {
  columns: (canManage: boolean) => ColDef[];
  rowBuffer: number;
  canManage: boolean;
  onConfirmSelected: (mail: OrderConfirmSnapshotType) => void;
  current: OrderConfirmSnapshotType | null;
  hideProject: boolean;
  isActiveTab: boolean;
}

interface ConfirmsListState {
  selection: OrderConfirmSnapshotType[];
  editable: SaveConfirm | null;
  assigment: OrderConfirmSnapshotType[];
  colDefs: ColDef[];
  showTools: boolean;
}
